import {
  ConvertToTenantAdminRequestDto,
  InvitationDto,
  InvitationRequestDto,
  KratosIdentityDto,
  KratosSessionDto,
  MemberDto,
  PermissionDto,
  PermissionUpdateDto,
} from '@careapp-group/ng-sdk-v2-new';

import { CareAppListActionFactory } from '../action-factory';
import { createAction, props } from '@ngrx/store';

class MembersActions extends CareAppListActionFactory<MemberDto> {
  get REQUEST_BULK_IMPORT() {
    return `${this.type}[Request] Bulk Import Staff`;
  }

  get RESPONSE_SUCCESS_BULK_IMPORT() {
    return `${this.type}[Response][Success] Bulk Import Staff`;
  }

  get RESPONSE_FAIL_BULK_IMPORT() {
    return `${this.type}[Response][Fail] Bulk Import Staff`;
  }

  get REQUEST_UPDATE_ROLE() {
    return `${this.type}[Request] Update Role`;
  }

  get RESPONSE_SUCCESS_UPDATE_ROLE() {
    return `${this.type}[Response][Success] Update Role`;
  }

  get RESPONSE_FAIL_UPDATE_ROLE() {
    return `${this.type}[Response][Fail] Update Role`;
  }

  get REQUEST_PERMISSIONS_ADMIN() {
    return `${this.type}[Request] Retrieve Permissions`;
  }

  get RESPONSE_SUCCESS_PERMISSIONS_ADMIN() {
    return `${this.type}[Response][Success] Retrieve Permissions`;
  }

  get RESPONSE_FAIL_PERMISSIONS_ADMIN() {
    return `${this.type}[Response][Fail] Retrieve Permissions`;
  }

  get REQUEST_SEARCH_ALL_MEMBERS_ADMIN() {
    return `${this.type}[Request] All members`;
  }

  RequestSearchAllMembers(payload: string) {
    return {
      type: this.REQUEST_SEARCH_ALL_MEMBERS_ADMIN,
      payload,
    };
  }

  RequestBulkImport(payload: InvitationRequestDto[]) {
    return {
      type: this.REQUEST_BULK_IMPORT,
      payload,
    };
  }

  ResponseSuccessBulkImport(payload: InvitationDto[]) {
    return {
      type: this.RESPONSE_SUCCESS_BULK_IMPORT,
      payload,
    };
  }

  ResponseFailBulkImport(payload: Error) {
    return {
      type: this.RESPONSE_FAIL_BULK_IMPORT,
      payload,
    };
  }

  RequestUpdateRole(payload: { id: string; role: PermissionUpdateDto }) {
    return {
      type: this.REQUEST_UPDATE_ROLE,
      payload,
    };
  }

  ResponseSuccessUpdateRole(payload: PermissionDto) {
    return {
      type: this.RESPONSE_SUCCESS_UPDATE_ROLE,
      payload,
    };
  }

  ResponseFailUpdateRole(payload: Error) {
    return {
      type: this.RESPONSE_FAIL_UPDATE_ROLE,
      payload,
    };
  }

  // Admin usage only.
  RequestPermissions(payload: { id: string }) {
    return {
      type: this.REQUEST_PERMISSIONS_ADMIN,
      payload,
    };
  }

  // Admin usage only.
  ResponseSuccessPermissions(payload: { id: string; permissions: PermissionDto[] }) {
    return {
      type: this.RESPONSE_SUCCESS_PERMISSIONS_ADMIN,
      payload,
    };
  }

  // Admin usage only.
  ResponseFailPermissions(payload: Error) {
    return {
      type: this.RESPONSE_FAIL_PERMISSIONS_ADMIN,
      payload,
    };
  }

  UpdateStaffFilterAction = createAction(
    this.UPDATE_FILTER,
    props<{
      payload: {
        enabled?: boolean;
        search?: string;
        orderBy?: 'member.firstName' | 'member.lastName' | 'member.email' | 'permission.externalId';
        order?: 'ASC' | 'DESC';
        modelName?: 'Tenant' | 'Organisation';
        roles?: string[];
      };
    }>()
  );

  RequestMemberIdentity = createAction(
    `${this.type}[Request] get identity`,
    props<{ memberId: string }>()
  );
  ResponseSuccessMemberIdentity = createAction(
    `${this.type}[Response][Success] get identity`,
    props<{ memberId: string; identity: KratosIdentityDto }>()
  );
  ResponseFailMemberIdentity = createAction(
    `${this.type}[Response][Fail] get identity`,
    props<{ memberId: string; error: any }>()
  );
  RequestMemberSessions = createAction(
    `${this.type}[Request] get sessions`,
    props<{ memberId: string }>()
  );
  ResponseSuccessMemberSessions = createAction(
    `${this.type}[Response][Success] get sessions`,
    props<{ memberId: string; sessions: KratosSessionDto[] }>()
  );
  ResponseFailMemberSessions = createAction(
    `${this.type}[Response][Fail] get sessions`,
    props<{ memberId: string; error: any }>()
  );

  RequestUpdatePermission = createAction(
    `${this.type}[Request] update permission`,
    props<{ permissionId: string; request: PermissionUpdateDto }>()
  );
  ResponseSuccessUpdatePermission = createAction(
    `${this.type}[Response][Success] update permission`,
    props<{ permission: PermissionDto }>()
  );
  ResponseFailUpdatePermission = createAction(
    `${this.type}[Response][Fail] update permission`,
    props<{ permissionId: string; error: any }>()
  );

  RequestTenantMemberById = createAction(
    `${this.type}[Request] get tenant member by ID`,
    props<{ memberId: string; tenantId?: string }>()
  );

  RequestConvertToTenantAdmin = createAction(
    `${this.type}[Request][Admin Only] Convert user to tenant admin`,
    props<{ memberId: string; tenantId: string }>()
  );
  ResponseSuccessConvertToTenantAdmin = createAction(
    `${this.type}[Response][Success][Admin Only] Convert user to tenant admin`,
    props<{ permission: PermissionDto }>()
  );
  ResponseFailConvertToTenantAdmin = createAction(
    `${this.type}[Response][Fail][Admin Only] Convert user to tenant admin`,
    props<{ memberId: string; tenantId: string; error: any }>()
  );

  RequestDeleteCredential = createAction(
    `${this.type}[Request][Admin Only] remove credential`,
    props<{ credentialType: string; memberId: string }>()
  );
  SuccessDeleteCredential = createAction(
    `${this.type}[Response][Success][Admin Only] remove credential`,
    props<{ identity: KratosIdentityDto; memberId: string }>()
  );
  ResponseFailDeleteCredential = createAction(
    `${this.type}[Response][Fail][Admin Only] remove credential`,
    props<{ error: any }>()
  );

  constructor() {
    super(`Members`);
  }
}

export const Members = new MembersActions();
